"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useTableData = void 0;
var apps_shared_1 = require("@l2p/apps-shared");
var date_fns_1 = require("date-fns");
var next_intl_1 = require("next-intl");
var react_1 = require("react");
var useTableData = function (data) {
    var t = (0, next_intl_1.useTranslations)('translation');
    return (0, react_1.useMemo)(function () {
        var table = {
            columns: [
                {
                    field: 'gameName',
                    label: t('gameName'),
                },
                {
                    field: 'totalBetAmount',
                    label: t('totalBet'),
                },
                {
                    field: 'totalWinAmount',
                    label: t('totalWin'),
                },
                {
                    field: 'date',
                    label: t('date'),
                },
            ],
            rows: [],
        };
        table.rows = data.map(function (item, idx) {
            var createdAt = item.createdAt, totalBetAmount = item.totalBetAmount, totalWinAmount = item.totalWinAmount, gameName = item.gameName, currency = item.currency;
            return {
                date: (0, date_fns_1.format)(new Date(createdAt), 'HH:mm, dd-LL-yy'),
                totalBetAmount: "".concat((0, apps_shared_1.getCurrencySymbol)(currency), " ").concat(totalBetAmount),
                totalWinAmount: "".concat((0, apps_shared_1.getCurrencySymbol)(currency), " ").concat(totalWinAmount),
                gameName: gameName,
                idx: idx,
            };
        });
        return table;
    }, [data, t]);
};
exports.useTableData = useTableData;
